<div *ngIf="pageInfo" class="container">
    <div class="bg-white pt-3">
        <h5>{{pageInfo.title}}</h5>
        <div class="row">
            <div class="col-sm-8">{{pageInfo.listDescription}}</div>
            <div class="col-sm-4">
                <a *ngIf="pageInfo.nextRoute != 'QuoteTemplate'" (click)="showEdit(pageInfo.nextRoute, null)" class="float-right btn btn-bidit-navigate btn-md mb-sm-3" i18n>Add</a>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <span i18n>Hide Inactive</span>
                <input (change)="toggleFilter(pageInfo.nextRoute)" type="checkbox"
                       name="showActive_{{pageInfo.title}}" class="bidit-switch-sm ml-1 mr-1" [checked]="showActive">
                <span i18n>Show All</span>
            </div>
        </div>
        <mat-table class="table-bidit table-striped table-border hover compact" style="width: 100%;" [dataSource]="dataSource"
                   matSort matSortActive="name" matSortDirection="asc">
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header">{{ pageInfo.label }}</mat-header-cell>
                <mat-cell *matCellDef="let entity">
                    <div *ngIf="pageInfo.nextRoute == 'Crew'; else defaultLabel">
                        <div>
                            <span>{{entity.name}}</span>
                            <span class="square float-right" [ngStyle]="{'background-color': entity.additionalInfo2}"></span>
                        </div>
                    </div>
                    <ng-template #defaultLabel>
                        {{entity.name}}
                    </ng-template>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="additionalInfo">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" >{{ additionalInfoLabel }}</mat-header-cell>
                <mat-cell *matCellDef="let entity">
                    {{ additionalInfoText(entity)}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="booleanInfo">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Primary</mat-header-cell>
                <mat-cell *matCellDef="let entity">
                    <mat-radio-group name="primary" [(ngModel)]="primaryOffice" (change)="primaryOfficeChanged($event)">
                        <mat-radio-button value="{{entity.id}}"></mat-radio-button>
                    </mat-radio-group>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Status</mat-header-cell>
                <mat-cell *matCellDef="let entity">
                  <div class="d-flex flex-row">
                    <label id="{{pageInfo.nextRoute}}_status_active{{entity.id}}" [ngClass]="{'text-success' : entity.isActive}" i18n>active</label>
                    <input *ngIf="pageInfo.nextRoute != 'user'" (change)="toggleStatus(pageInfo.nextRoute, entity.id)" type="checkbox" name="status_{{entity.id}}" id="status_{{entity.id}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!entity.isActive">
                    <input *ngIf="pageInfo.nextRoute == 'user'" (change)="toggleUserStatus(pageInfo.nextRoute, entity.id)" type="checkbox" name="status_{{entity.id}}" id="status_{{entity.id}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!entity.isActive">
                    <label id="{{pageInfo.nextRoute}}_status_inactive{{entity.id}}" [ngClass]="{'text-danger' : !entity.isActive}" i18n>inactive</label>

                    <a class="btn-bidit-edit-dark ml-4" role="button" (click)="showEdit(pageInfo.nextRoute, entity.id)"></a>
                    <button *ngIf="pageInfo.nextRoute=='Document'" (click)="downloadAttachment(entity)" class="btn btn-bidit-navigate ml-3 mr-1" i18n>Download</button>
                  </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <mat-paginator [length]="genericModelList?.length" [pageSize]="10" [pageSizeOptions]="[10]"></mat-paginator>
    </div>
</div>
